import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import { ApiGatewayMutations } from "@/api/apiGateway/mutations"

export interface IBillMutator {
  issueBill(id: number): MutationResult<unknown>
}

class BillMutatorClass implements IBillMutator {
  issueBill(id: number) {
    return useMutation({
      ...ApiGatewayMutations.bill.issue(id),
      serializerFn: (data) => data,
      invalidateCache: false,
    })
  }
}

export const BillMutator = new BillMutatorClass()
